module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-layout-masonry"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n      Masonry Layout.\n    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "grid",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "data-masonry": "{ \"columnWidth\": 200 }"
    }
  }, _vm._l((_vm.images), function(image) {
    return _c('div', {
      staticClass: "grid-item"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": image.image_900
      }
    })])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "container masonry-container"
  }, [_c('div', {
    directives: [{
      name: "masonry",
      rawName: "v-masonry"
    }],
    staticClass: "masonry-wrapper",
    attrs: {
      "transition-duration": "0.3s",
      "item-selector": ".masonry-item",
      "is-fit-width": "true",
      "data-masonry-options": "{ 'isFitWidth': true }"
    }
  }, _vm._l((_vm.images), function(image, index) {
    return _c('div', {
      directives: [{
        name: "masonry-tile",
        rawName: "v-masonry-tile"
      }],
      staticClass: "masonry-item"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-image"
    }, [_c('figure', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": image.image_900,
        "alt": "Image"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "media"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "media-content"
    }, [_c('p', {
      staticClass: "title is-4"
    }, [_vm._v(_vm._s(image.title))]), _vm._v(" "), _c('p', {
      staticClass: "subtitle is-6"
    }, [_vm._v("@" + _vm._s(image.title.replace(/\s+/g, '')))])])]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_vm._v("\n              " + _vm._s(image.description) + " "), _c('a', [_vm._v("@architecture")]), _vm._v(".\n              "), _c('a', [_vm._v("#elegant")]), _vm._v(" "), _c('a', [_vm._v("#design")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm._f("datetime")(image.created_at)))])])])])])
  })), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "control notification is-danger"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.error = undefined
      }
    }
  }), _vm._v("\n      " + _vm._s(_vm.error) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('section-comment', {
    staticStyle: {
      "margin-top": "50px"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "subtitle",
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_vm._v("\n      Creating Pinterest-like Masonry layout."), _c('br'), _vm._v("\n      Reference: "), _c('a', {
    attrs: {
      "href": "https://www.sitepoint.com/understanding-masonry-layout/",
      "target": "_blank"
    }
  }, [_vm._v("Sitepoint - Understanding Masonry Layout")]), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/shershen08/vue-masonry"
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-github color-red"
  }), _vm._v("    shershen08 / Vue-Masonry")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-left"
  }, [_c('figure', {
    staticClass: "image is-48x48"
  }, [_c('img', {
    staticStyle: {
      "border-radius": "30px"
    },
    attrs: {
      "src": "http://bulma.io/images/placeholders/96x96.png",
      "alt": "Image"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37202ca9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages_showcase/LayoutMasonry.vue
// module id = 812
// module chunks = 1